import styled from 'styled-components';

const ZiggyAwardsStyle = styled.div`
	&.ziggyAwards {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 240%;
		transform: translate3d(-50%, -50%, 0);
		background: var(--color1);

		& > div {
			mix-blend-mode: difference;
		}
	}
`;

export default ZiggyAwardsStyle;
